import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Errors } from 'react-redux-form';
import { actions as formActions } from 'react-redux-form';
import { SearchForProfessionWithHelp } from 'components/professionTypes/searchForProfessionWithHelp';
import scroll from 'utilities/scroll';
import PropTypes from 'prop-types';
import { formatText } from 'core/i18n';
import { isMobile } from 'utilities/browser';

class ProfessionFinder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            option1Selected: false,
            option2Selected: false,
            currentOption: null,
        };
        this.buildBlock = this.buildBlock.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.onFocusAnimate = this.onFocusAnimate.bind(this);
        this.setSelectedCard = this.setSelectedCard.bind(this);
        this.renderErrors = this.renderErrors.bind(this);
        this.changeClassError = this.changeClassError.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { userProfile } = this.props;
        if (userProfile['profession_option']) {
            this.setSelectedCard(userProfile['profession_option']);
            this.setState({
                currentOption: userProfile['profession_option'],
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { userProfile } = this.props;

        if (prevProps.userProfile['profession_option'] !== userProfile['profession_option']) {
            this.setState({
                currentOption: userProfile['profession_option'],
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { userProfileForm } = nextProps;
        if (typeof userProfileForm['profession_option'] !== 'undefined') {
            this.changeClassError(!userProfileForm['profession_option'].valid);
        }
    }

    changeClassError(change) {
        const classError = change ? 'form__input--error valid-error' : '';
        this.setState({
            classError,
        });
    }

    setSelectedCard(value) {
        switch (value) {
            case '1':
                this.setState({
                    option1Selected: true,
                    option2Selected: false,
                });
                break;
            case '2':
                this.setState({
                    option1Selected: false,
                    option2Selected: true,
                });
                break;
            default:
                this.setState({
                    option1Selected: false,
                    option2Selected: false,
                });
                break;
        }
    }

    handleOnChange(e) {
        const { formActions, handleSave, onFieldChange } = this.props;
        const value = e.target ? e.target.value : e.value;
        formActions.change('userProfile.profession_option', value);
        formActions.change('userProfile.profession_category', '');
        formActions.change('userProfile.cno1_profession_id', '');
        formActions.change('userProfile.cno2_profession_id', '');

        // Reset validations
        formActions.setValidity('userProfile.profession_category', { required: true });
        formActions.setValidity('userProfile.cno1_profession_id', { required: true });
        formActions.setValidity('userProfile.cno2_profession_id', { required: true });

        if (handleSave) {
            formActions.setValidity('userProfile.profession_option', { required: true });
            handleSave('profession', {
                option: value,
                id: '',
                subcategory: '',
            });
        }
        this.setSelectedCard(value);
        if (onFieldChange) onFieldChange(value);
    }

    handleOnClickBlock = e => {
        if (!this.props.disabled) {
            const element = e.currentTarget.querySelector('input[type=radio]');
            if (element && this.state.currentOption !== element.value) {
                this.handleOnChange(element);
                element.checked = true;

                const elementClass = e.target.className.toString();
                if (
                    elementClass.search('react-autosuggest__input') == -1 &&
                    elementClass.search('Select-placeholder') == -1 &&
                    elementClass.search('react-autosuggest__suggestion-item') == -1
                ) {
                    this.onFocusAnimate(element);
                }

                this.setState({
                    currentOption: element.value,
                });
            }
        }
    };

    onFocusAnimate(element) {
        const parentElement = element;
        scroll.transition(parentElement);
    }

    buildBlock() {
        const { userProfile, messagesError, handleSave, disabled, onActivityChange } = this.props;
        const classError = this.state.classError;

        return (
            <div>
                <div className="md-form-group">
                    <ul className={`form__radio-list ${classError}`}>
                        <li
                            onClick={!isMobile() ? this.handleOnClickBlock : null}
                            onTouchStart={isMobile() ? this.handleOnClickBlock : null}
                        >
                            <input
                                type="radio"
                                id="option2"
                                name="professionalOption"
                                defaultValue="2"
                                className="form__radio"
                                defaultChecked={true}
                                disabled={disabled}
                            />
                            <div>
                                <SearchForProfessionWithHelp
                                    typeCnaeCno={'02'}
                                    handleSave={handleSave}
                                    title={formatText('cnaeOrCno-professionSelected')}
                                    placeholder={formatText('cnaeOrCno-option2Placeholder')}
                                    modelName={'cno2_'}
                                    disabled={disabled}
                                    professionalOption={userProfile['profession_option']}
                                    onChange={onActivityChange}
                                />
                            </div>
                        </li>
                    </ul>
                    <Errors
                        model={'userProfile.profession_option'}
                        messages={messagesError}
                        component={this.renderErrors}
                    />
                </div>
            </div>
        );
    }

    renderErrors(props) {
        return <p className="form__field_error">{props.children}</p>;
    }

    render() {
        return this.buildBlock();
    }
}

ProfessionFinder.propTypes = {
    messagesError: PropTypes.object,
};

ProfessionFinder.defaultProps = {
    messagesError: { required: formatText('validation-radioRequired'), valid: formatText('validation-text') },
};

module.exports.constructor = ProfessionFinder;
module.exports.ProfessionFinder = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(ProfessionFinder);
